import { PageWithIframeLayout } from './PageWithIframeLayout';
import { useAppStore } from '../stores/useAppStore';

function PageCiscoAtAi4() {
  const { content } = useAppStore();
  const iframeSrc = content.cisco_at_ai4.iframe_src;
  
  return (
    <PageWithIframeLayout iframeSrc={iframeSrc} />
  );
}

export default PageCiscoAtAi4;